<ng-container *ngIf="hasReports">
    <div class="card new-card">
        <app-card-title title="RaioX Técnico" icon="app-icon-graph"></app-card-title>
        <ng-container *ngIf="data.audio?.url">
            <div class="sub-header">
                Ouça a avaliação do profissional
            </div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <app-audio-player [audioURL]="data?.audio?.url" [duration]="20" [backgroundColor]="'#EBECED'"
                        [inputColor]="'#16B097'">
                    </app-audio-player>
                </div>
            </div>
        </ng-container>
        <div class="sub-header" [style.color]="titleColor">
            Confira a avaliação detalhada
        </div>
        <ng-container *ngFor="let item of reportItemsWithName">
            <app-report-item-view [item]="item" [titleColor]="titleColor"></app-report-item-view>
        </ng-container>
    </div>
</ng-container>